// Global packages and components
import { clsx } from 'clsx'
import { HssLoader } from '~/components'

// Types
import type { ReactNode } from 'react'

interface Props {
  children?: ReactNode
  fillParent?: boolean
  background?: 'neutral' | 'white' | 'transparent'
  opacity?: boolean
}

// Main export
const InlineLoader = ({
  children,
  fillParent = false,
  background = 'neutral',
  opacity = false,
}: Props) => (
  <div
    className={clsx(
      'mb-10 flex w-full flex-col items-center rounded-2xl px-8 py-14 text-center',
      {
        'bg-neutral-100': background === 'neutral' && !opacity,
        'bg-neutral-100/80': background === 'neutral' && opacity,
        'bg-white': background === 'white' && !opacity,
        'bg-white/80': background === 'white' && opacity,
        'h-full': fillParent,
      }
    )}
  >
    <div
      className={clsx({
        'mb-5': children,
      })}
    >
      <HssLoader />
    </div>
    {children}
  </div>
)

export default InlineLoader
